import { LOGIN_OR_SIGNUP_PATH } from 'paths'
import { ButtonLink } from './Button'
import { Blaze } from 'blaze-ui/icons'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useDefaultTheme } from 'hooks/useDefaultTheme'

const Icon = () => {
  const { isMobile } = useResponsiveDesign()
  const defaultTheme = useDefaultTheme()
  const color = defaultTheme === 'light' ? 'var(--dark-80)' : 'var(--editor-top)'

  return <Blaze color={color} size={isMobile ? 24 : 20} />
}

export const TryBlazeButton = () => {
  return (
    <ButtonLink to={LOGIN_OR_SIGNUP_PATH} icon={Icon} aria-label="Sign In">
      Sign In
    </ButtonLink>
  )
}
